import { useCallback, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { postLandingVisit } from "@/lib/api";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const HEARTBEAT_MS = 20000;

export const readUtm = (search) => {
  const params = new URLSearchParams(search);
  return Object.fromEntries(UTM_KEYS.map((k) => [k, params.get(k) || undefined]));
};

export const utmSource = (utm) =>
  [utm.utm_source, utm.utm_campaign, utm.utm_content].filter(Boolean).join(" / ") || "direct";

const uid = () => (window.crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

// Heartbeat while the page is open so the visit's UTM can be tied to any booking or callback that follows.
export const useLandingVisit = (page, serviceKey) => {
  const { search } = useLocation();
  const utm = useMemo(() => readUtm(search), [search]);
  const interacting = useRef(false);
  const send = useRef(() => {});

  useEffect(() => {
    const visitId = sessionStorage.getItem("lumiere-visit") || uid();
    sessionStorage.setItem("lumiere-visit", visitId);
    send.current = () =>
      postLandingVisit({ visit_id: visitId, page, service_key: serviceKey, ...utm, interacting: interacting.current }).catch(() => {});
    send.current();
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") send.current();
    }, HEARTBEAT_MS);
    return () => clearInterval(timer);
  }, [page, serviceKey, utm]);

  const markInteracting = useCallback(() => {
    if (interacting.current) return;
    interacting.current = true;
    send.current();
  }, []);

  return { utm, source: utmSource(utm), markInteracting };
};
